import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";
import styles from "./MediaCoverageSlider.module.css";
import mediaCoverageData from "../../../json/mediaCategories.json";

const MediaCoverageSlider = () => {
  const sliderRef = useRef(null);
  const { slides } = mediaCoverageData;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const formatSlugToTitle = (slug) => {
    if (!slug) return "";
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const sectionSlug = queryParams.get("section");
  const categorySlug = queryParams.get("category");

  const filteredSlides = slides.filter((item) => {
    if (!sectionSlug && !categorySlug) return true;
    if (sectionSlug && !categorySlug) {
      return item.section === sectionSlug;
    }
    return item.section === sectionSlug && item.category === categorySlug;
  });

  const getPadding = () => {
    if (screenWidth <= 768) return "40px";
    if (screenWidth <= 1024) return "120px";
    return "250px";
  };

  const settings = {
    centerMode: true,
    centerPadding: getPadding(),
    slidesToShow: 1,
    arrows: false,
    infinite: true,
    speed: 600,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "120px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
    ],
  };

  const renderTitle = (text) => {
    const parts = text.split(/(')/g);

    return parts.map((part, index) => {
      if (part === "'") {
        return (
          <span key={index} className={styles.diffentFamily}>
            '
          </span>
        );
      }
      return <React.Fragment key={index}>{part}</React.Fragment>;
    });
  };

  return (
    <div className={styles.containerBox}>
      <div className={styles.wrapper}>
        <Slider key={screenWidth} ref={sliderRef} {...settings}>
          {filteredSlides.map((item) => (
            <div key={item.id}>
              <div className={styles.slide}>
                <div className={styles.imageSection}>
                  <img src={item.img} alt={item.title} loading="lazy" decoding="async" />
                </div>

                <div className={styles.contentSection}>
                  <span className={styles.badge}>{item.badge}</span>
                  <h2>{renderTitle(item.title)}</h2>
                  <p>{item.desc}</p>
                  <span className={styles.date}>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Navigation Buttons */}
        <div className={styles.nav}>
          <button onClick={() => sliderRef.current?.slickPrev()}>
            ← Previous
          </button>

          <button onClick={() => sliderRef.current?.slickNext()}>Next →</button>
        </div>

        <div className={styles.line}></div>
      </div>
    </div>
  );
};

export default MediaCoverageSlider;
